import { render, staticRenderFns } from "./BankAccountMaster.vue?vue&type=template&id=36fc7b15&"
import script from "./BankAccountMaster.vue?vue&type=script&lang=js&"
export * from "./BankAccountMaster.vue?vue&type=script&lang=js&"
import style0 from "./BankAccountMaster.vue?vue&type=style&index=0&id=36fc7b15&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports